package dev.krno.components

import androidx.compose.runtime.Composable
import dev.krno.data.EventData
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.Br
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.Section
import org.jetbrains.compose.web.dom.Small
import org.jetbrains.compose.web.dom.Text

@Composable
fun Partners() {
    Section(attrs = { classes("wrap", "partners") }) {
        Div {
            Div(attrs = {
                classes("label")
                style { property("margin-bottom", "10px") }
            }) { Text("Made possible by") }
            H2(attrs = {
                style {
                    property("font-size", "clamp(30px, 3.6vw, 42px)")
                    property("letter-spacing", "-.035em")
                }
            }) {
                Text("Partners")
                Br()
                Text("& sponsor")
            }
        }
        Div(attrs = { classes("plist") }) {
            EventData.partners.forEach { p ->
                if (p.url.isNotEmpty()) {
                    A(href = p.url, attrs = {
                        classes("plogo")
                        attr("target", "_blank")
                        attr("rel", "noopener noreferrer")
                        attr("aria-label", "${p.name} — opens in a new tab")
                    }) {
                        Text(p.name)
                        Small { Text(p.role) }
                    }
                } else {
                    Div(attrs = { classes("plogo") }) {
                        Text(p.name)
                        Small { Text(p.role) }
                    }
                }
            }
        }
    }
}
